import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import useAppUser from 'hooks/useAppUser';
import useNotify from 'hooks/useNotify';
import { DBS_SETTINGS_BASE_QUERY_KEY } from '../useFetchDbsSettings';
import useUpdateDbsSettingsMutation from '../useUpdateDbsSettingsMutation';

/**
 * The checkbox writes the agency's white label flag, the same column the booking site reads
 * to decide whether to serve a custom domain.
 */
const useUpdateWhiteLabelEnabled = () => {
  const { agencyUid } = useAppUser();
  const queryClient = useQueryClient();
  const { notifyError, notifySuccess } = useNotify();
  const { t } = useTranslation();

  const { mutateAsync, isLoading } = useUpdateDbsSettingsMutation({
    onSuccess: (data) => {
      queryClient.setQueryData([DBS_SETTINGS_BASE_QUERY_KEY, agencyUid], data);
      notifySuccess(
        t('pageDirectBookingEngine.whiteLabelSettings.enabledSaved'),
      );
    },
    onError: () => {
      notifyError(
        t('pageDirectBookingEngine.whiteLabelSettings.enabledSaveError'),
      );
    },
  });

  return {
    updateWhiteLabelEnabled: (whiteLabelEnabled: boolean) =>
      mutateAsync({ agencyUid: agencyUid!, payload: { whiteLabelEnabled } }),
    isSavingWhiteLabelEnabled: isLoading,
  };
};

export default useUpdateWhiteLabelEnabled;
